<template>
  <n-checkbox
    v-model:checked="geoRestricted"
    @update:checked="handleCheck"
  >
    <div>
      {{ t('components.settings.geoRestriction.label') }}
    </div>
  </n-checkbox>
</template>

<script setup lang="ts">
import {ref} from 'vue'
import {useStore} from 'vuex'
import {useI18n} from 'vue-i18n'

const {t} = useI18n()

const geoRestricted = ref(false)

const store = useStore()

const handleCheck = ref((checked: boolean) => {
  store.dispatch('Settings/SET_GEO_RESTRICTION', checked)
})
</script>

<style scoped>

</style>
